import React, { Component } from 'react';
import './App.css';
import { withRouter, Switch, Route, Redirect } from 'react-router-dom';
import { Layout, Menu, Icon, ConfigProvider } from 'antd';
import MessageList from './messageManage/messageList/messageList'
import WelcomePage from './messageManage/welcomePage/welcomePage'
import zhCN from 'antd/es/locale/zh_CN';

const { Header, Sider, Content } = Layout;
const SubMenu = Menu.SubMenu;

class App extends Component {
  state = {
    collapsed: false,
    menuItemKey: []
  };

  componentDidMount() {
    let menuItemKey = localStorage.getItem('menuItemKey');
    if (menuItemKey) {
      this.setState({ menuItemKey: [menuItemKey] })
      this.props.history.replace('/messageList/' + menuItemKey)

    }
  }

  getUrlToken(name, str) {
    const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`);
    const r = str.substr(1).match(reg);
    if (r != null) return decodeURIComponent(r[2]); return null;
  }

  toggle = () => {
    this.setState({
      collapsed: !this.state.collapsed,
    });
  }

  goPage(key) {
    console.log('key=', key)
    localStorage.setItem('menuItemKey', key);
    this.setState({ menuItemKey: [String(key)] })
    //sub1
    if (key >= 1 && key <= 6) {
      this.props.history.replace('/messageList/' + key)
    }
  }

  render() {
    const { menuItemKey } = this.state;
    return (
      <Layout>
        <Header style={{ background: 'linear-gradient(#191970,#ADD8E6)', padding: 0, height: '7vh', lineHeight: '7vh' }}>
          <Icon
            className="trigger"
            type={this.state.collapsed ? 'menu-unfold' : 'menu-fold'}
            onClick={this.toggle}
            style={{ fontSize: "1.8rem", marginLeft: "0.5rem" }}
          />
          <span style={{ fontSize: "1.8rem", marginLeft: "0.5rem" }}>铛铛留言管理系统</span>
          <span className={'head-span'}></span>
        </Header>
        <Layout style={{ maxHeight: '93vh', overflow: 'hidden' }}>
          <Sider
            trigger={null}
            collapsible
            collapsed={this.state.collapsed}
            style={{ minHeight: "100vh" }}
          >
            <Menu
              theme="dark"
              mode="inline"
              defaultSelectedKeys={['1']}
              defaultOpenKeys={['sub1']}
              selectedKeys={menuItemKey || ['1']}
            >
              <SubMenu
                key="sub1"
                title={<span><Icon type="book" onClick={this.toggle} /><span>留言模块</span></span>}
              >
                <Menu.Item key="1" onClick={this.goPage.bind(this, 1)}>广场</Menu.Item>
                <Menu.Item key="2" onClick={this.goPage.bind(this, 2)}>资讯</Menu.Item>
                <Menu.Item key="3" onClick={this.goPage.bind(this, 3)}>附近的人</Menu.Item>
                <Menu.Item key="4" onClick={this.goPage.bind(this, 4)}>红包天天乐</Menu.Item>
                <Menu.Item key="5" onClick={this.goPage.bind(this, 5)}>添加朋友</Menu.Item>
                <Menu.Item key="6" onClick={this.goPage.bind(this, 6)}>朋友消息</Menu.Item>
              </SubMenu>
            </Menu>
          </Sider>
          <Content style={{ margin: '24px 16px', padding: 24, background: '#fff', minHeight: 280 }}>
            <ConfigProvider locale={zhCN}>
              <Switch>
                <Route exact path="/welcomePage" component={WelcomePage}></Route>
                <Route exact path="/messageList/:key" component={MessageList}></Route>
                <Redirect to={'/welcomePage'} component={WelcomePage} />
              </Switch>
            </ConfigProvider>
          </Content>
        </Layout>
      </Layout>
    );
  }
}

export default withRouter(App);